import { render, staticRenderFns } from "./gearraInfo.vue?vue&type=template&id=58b8d5c7&scoped=true&"
import script from "./gearraInfo.vue?vue&type=script&lang=ts&"
export * from "./gearraInfo.vue?vue&type=script&lang=ts&"
import style0 from "./gearraInfo.vue?vue&type=style&index=0&id=58b8d5c7&lang=scss&scoped=true&"
import style1 from "./gearraInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b8d5c7",
  null
  
)

export default component.exports